import { AddressInterface } from '../../models/address.interface';

export interface AddressInterfaceState {
  address: Array<AddressInterface>;
}

export const initialAddressState: AddressInterfaceState = {
  address: null
};
